import React, { useState } from 'react'
import { useStateValue } from '../state'

export const CardFilter = () => {
  const [currentState, dispatch] = useStateValue()
  const [filterOpen, setFilterOpen] = useState(false)
  const [selectedOption, setSelectedOption] = useState('both')
  const [chapterVal, setChapterVal] = useState('all')

  const handleFilters = () => {
    let chapterFiltered = currentState.flashcards
    if (chapterVal !== 'all') {
      chapterFiltered = currentState.flashcards.filter(
        c => c.chapter === chapterVal
      )
    }

    let dispatchVal
    switch (selectedOption) {
      case 'both':
        dispatchVal = chapterFiltered
        break
      case 'myCards':
        dispatchVal = chapterFiltered.filter(c => c.userCreated)
        break
      default:
        dispatchVal = chapterFiltered.filter(c => !c.userCreated)
    }
    dispatch({
      type: 'updateCards',
      payload: dispatchVal,
    })
  }

  return (
    <div className="filter-container">
      <div className="d-flex justify-content-end">
        <button
          className="btn btn-myed btn-default btn-defaulty-myed btn-lg-myed"
          onClick={() => setFilterOpen(!filterOpen)}
        >
          Filter
          <i className={`fas fa-chevron-${filterOpen ? 'up' : 'down'} ml-2`} />
        </button>
      </div>
      <div className={`filter-menu ${filterOpen ? 'open' : ''}`}>
        <div className="d-flex flex-column flex-md-row align-items-center justify-content-center">
          <div className="w-100 w-md-25 text-md-right mb-md-0">
            <label className="mr-md-3">
              <strong>Option</strong>
            </label>
          </div>
          <div className="w-100 w-md-75">
            <div>
              <input
                type="radio"
                id="both"
                name="option"
                value="both"
                checked={selectedOption === 'both'}
                onChange={() => setSelectedOption('both')}
              />
              <label htmlFor="both" className="ml-2">
                Both
              </label>
            </div>
            <div>
              <input
                type="radio"
                id="myCards"
                name="option"
                value="myCards"
                checked={selectedOption === 'myCards'}
                onChange={() => setSelectedOption('myCards')}
              />
              <label htmlFor="myCards" className="ml-2">
                My Cards Only
              </label>
            </div>
            <div>
              <input
                type="radio"
                id="bookTerms"
                name="option"
                value="bookTerms"
                checked={selectedOption === 'bookTerms'}
                onChange={() => setSelectedOption('bookTerms')}
              />
              <label htmlFor="bookTerms" className="ml-2">
                Book Terms Only
              </label>
            </div>
          </div>
        </div>
        <div className="d-flex flex-column flex-md-row justify-content-center align-items-center mt-2">
          <div className="w-100 w-md-25 text-md-right mb-2 mb-md-0">
            <label className="mr-md-3" htmlFor="chapterSelect">
              <strong>Select Chapter</strong>
            </label>
          </div>
          <div className="w-100 w-md-75">
            <select
              id="chapterSelect"
              className="w-100 form-control"
              value={chapterVal}
              onChange={e => setChapterVal(e.target.value)}
            >
              <option value="all">All Chapters</option>
              {currentState.chapters.map((chap, idx) => (
                <option key={idx} value={chap[0]}>
                  {chap[1]}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="text-center mt-3">
          <button
            onClick={handleFilters}
            className="btn btn-myed btn-primary btn-primary-myed btn-sm-myed"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  )
}
